import { setMeeting } from "./MeetingDataSlice";
import {
  fetchMeetingsThunk,
  cancelMeetingAdvanced,
  rescheduleMeetingAdvanced,
} from "./MeetingDataSlice";
import { getPusherClient } from "@/lib/services/pusher-client";

export const fetchMeetings = () => (dispatch) => {
  return dispatch(fetchMeetingsThunk());
};

export const setupPusherChannel = (userId) => (dispatch) => {
  const pusherClient = getPusherClient();

  if (!pusherClient) {
    return () => {};
  }

  if (!pusherClient.config.authEndpoint) {
    pusherClient.config.authEndpoint = `${process.env.NEXT_PUBLIC_APP_URL}/api/pusher/auth`;
  }

  const channelName = `private-user-${userId}`;
  const channel = pusherClient.subscribe(channelName);

  channel.bind("meeting-updated", (data) => {
    if (data.meeting) {
      const processedMeeting = {
        ...data.meeting,
        status_time: data.meeting.status_time
          ? new Date(data.meeting.status_time)
          : null,
        created_at: data.meeting.created_at
          ? new Date(data.meeting.created_at)
          : null,
        updated_at: data.meeting.updated_at
          ? new Date(data.meeting.updated_at)
          : null,
        status_log: Array.isArray(data.meeting.status_log)
          ? data.meeting.status_log.map((log) => ({
              ...log,
              time: log.time ? new Date(log.time) : null,
            }))
          : [],
      };

      dispatch(setMeeting(processedMeeting));
    }
  });

  channel.bind("pusher:subscription_error", (error) => {});

  channel.bind("pusher:subscription_succeeded", () => {});

  pusherClient.connection.bind("connected", () => {});

  pusherClient.connection.bind("disconnected", () => {});

  pusherClient.connection.bind("error", (error) => {});

  return () => {
    if (channel) {
      channel.unbind_all();
      pusherClient.unsubscribe(channelName);
    }
  };
};

export const setupHybridMeetingUpdates = (userId) => (dispatch) => {
  const pusherCleanup = dispatch(setupPusherChannel(userId));

  return () => {
    pusherCleanup();
  };
};

export const listenToFirestoreMeetings = (userId) => (dispatch) => {
  if (userId) {
    dispatch(fetchMeetings());

    return dispatch(setupHybridMeetingUpdates(userId));
  } else {
    return () => {};
  }
};

// Advanced cancel and reschedule thunks
export const cancelMeetingAdvancedThunk =
  (payloadOrMeetingId, userRole) => (dispatch) => {
    const payload =
      typeof payloadOrMeetingId === "object" && payloadOrMeetingId !== null
        ? payloadOrMeetingId
        : { meetingId: payloadOrMeetingId, userRole };

    const request = dispatch(cancelMeetingAdvanced(payload));

    // Keep dashboard/lists consistent when realtime update is delayed.
    request.then((action) => {
      if (cancelMeetingAdvanced.fulfilled.match(action)) {
        dispatch(fetchMeetingsThunk());
      }
    });

    return request;
  };

export const rescheduleMeetingAdvancedThunk =
  (meetingId, newDateTime, userRole) => (dispatch) => {
    return dispatch(
      rescheduleMeetingAdvanced({ meetingId, newDateTime, userRole }),
    );
  };
